<template>
  <div>
    <h2>Administration</h2>
    <router-view />
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>